import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { collectPlusMenuItems } from '#pplx/frontend/composer-sdk/internal/plus-menu/collectPlusMenuItems.js';
import { useEffect, useRef, useState } from 'react';
/** Collects mounted plugin plus-menu items for the composer plus-menu host. */
export function usePlusMenuItems(plugins, isMenuOpen) {
    const [items, setItems] = useState(EMPTY_ARRAY);
    const loadedPluginsRef = useRef(undefined);
    useEffect(() => {
        if (loadedPluginsRef.current === plugins) {
            return;
        }
        loadedPluginsRef.current = undefined;
        if (!isMenuOpen) {
            setItems(EMPTY_ARRAY);
            return;
        }
        // Keep mounted items' local state while their replacement collection loads.
        const pluginIds = new Set(plugins.map((plugin) => plugin.id));
        setItems((previousItems) => previousItems.filter((item) => pluginIds.has(item.pluginId)));
        let isCurrent = true;
        void collectPlusMenuItems(plugins).then((loadedItems) => {
            if (isCurrent) {
                loadedPluginsRef.current = plugins;
                setItems(loadedItems);
            }
        });
        return () => {
            isCurrent = false;
        };
    }, [isMenuOpen, plugins]);
    return items;
}
//# sourceMappingURL=usePlusMenuItems.js.map